import { useFlags } from "launchdarkly-react-client-sdk";
import { SettingsIcon } from "lucide-react";
import { Helmet } from "react-helmet-async";

import WeldLogo from "@/components/elements/Weldlogo";

export type MaintenanceProviderProps = JSX.IntrinsicAttributes &
  React.PropsWithChildren;

export function MaintenanceProvider(props: MaintenanceProviderProps) {
  const { appDownForMaintenance } = useFlags();
  if (appDownForMaintenance) {
    return <MaintenancePage />;
  }
  return <>{props.children}</>;
}

function MaintenancePage() {
  return (
    <>
      <Helmet>
        <title>Weld - Maintenance</title>
      </Helmet>
      <div className="fixed inset-0">
        <div className="flex h-full w-full flex-col">
          <div className="mt-8 flex-none pb-4">
            <WeldLogo className="mx-auto h-3 w-auto" />
          </div>
          <div className="flex grow items-center justify-center">
            <div className="flex flex-col items-center px-20">
              <div className="relative flex h-36 w-36 items-center justify-center sm:h-48 sm:w-48 md:h-64 md:w-64">
                <SettingsIcon className="absolute inset-0 h-full w-full animate-spin-super-slow text-gray-200 dark:text-gray-700" />
              </div>
              <h1 className="mt-4 mb-8 text-2xl xs:text-4xl">
                We'll be back soon!
              </h1>

              <p className="text-center leading-relaxed">
                We're very sorry for the inconvenience but we're performing some
                maintenance at the moment. Please check back soon...
              </p>
              <p className="mt-6">
                Your syncs are not affected by this maintenance. They will
                continue to run as scheduled.
              </p>
              <p className="mt-8 italic">- The Weld Team</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
